import { activeTheme, usePreview, useTheme } from "@/lib/theme";

const SPOTS = ["18% 12%", "82% 8%", "70% 62%", "12% 78%", "50% 40%", "92% 90%"];
const alpha = (c, a) => {
  if (c.startsWith("#")) { const n = parseInt(c.slice(1), 16); return `rgba(${n >> 16},${(n >> 8) & 255},${n & 255},${a})`; }
  return c.replace("rgb(", "rgba(").replace(")", `,${a})`);
};
const mesh = (colors) => colors.map((c, i) => `radial-gradient(42% 48% at ${SPOTS[i % SPOTS.length]}, ${alpha(c, 0.72)}, transparent 72%)`).join(",");

/* Full-viewport colour mesh behind the app shell, built from the active theme's palette; a hover preview layer fades in above it. */
export const ThemeBackground = () => {
  const s = useTheme();
  const theme = activeTheme(s);
  const preview = usePreview();
  const show = s.enabled && preview;
  return (
    <div className="pointer-events-none fixed inset-0 z-0" data-testid="theme-background" data-theme={theme ? `${theme.kind}:${theme.id}` : ""} data-preview={show ? "1" : "0"}>
      <div className="absolute inset-0 transition-opacity duration-1000" style={{ opacity: theme && !show ? 1 : 0, backgroundImage: theme ? mesh(theme.colors) : "none" }} />
      <div className="absolute inset-0 transition-opacity duration-300" data-testid="theme-preview-layer" style={{ opacity: show ? 1 : 0, backgroundImage: show ? mesh(preview) : "none" }} />
      <div className="absolute inset-0 bg-[linear-gradient(180deg,rgba(250,249,246,0)_0%,rgba(250,249,246,0.25)_60%,rgba(250,249,246,0.5)_100%)]" style={{ opacity: show ? (show.length ? 1 : 0) : theme ? 1 : 0 }} />
    </div>
  );
};
